import {drawPagesContent} from "./EditScreenLayout";
import * as NamaURLS from "../../constants/NamaURLS";
import {isBarcodeOn} from "../../login/ClientCache";
import {currentUserId} from "../../login/LoginPresenter";
import {ajaxJSON} from "../../common/NamaCommon";

/**
 *
 * @param appendTo {NamaJquery|HTMLElement}
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
export function drawTermEditScreen(appendTo, presenter, root) {
    let container = appendTo;
    removeOldTabs(container, presenter);
    drawPagesContent(container, presenter, 1);
    return appendTo;

}

export function removeOldTabs(container, presenter) {
    let tabStrip = container.data("kendoTabStrip");
    let tabs = tabStrip.items().length;
    for (let i = tabs - 1; i >= 1; i--) {
        tabStrip.remove(i);
        presenter.dataWidgets.delete(i);
    }
    presenter._pageIndex = 0;
}

export function startTermOrConfigEntryEditScreen(presenter, layoutKey, isForConfigEntry) {
    presenter._pageIndex = 0;
    if (presenter.currentLayoutKey && presenter.currentLayoutKey === layoutKey)
        return;
    presenter.currentLayoutKey = layoutKey;
    let tabStrip = presenter.view.find("#tabstrip");
    let serviceUrl = NamaURLS.FetchTermScreens;
    if (isForConfigEntry)
        serviceUrl = NamaURLS.FetchConfigEntriesScreens;
    return ajaxJSON(serviceUrl, {
            request: JSON.stringify({
                userId: currentUserId(),
                barCodeOn: isBarcodeOn(),
            })
        }, (result) => {
            let termEditScreen = result.data.screens[layoutKey];
            presenter.preferences.editLayout = termEditScreen;
            if (presenter.preferences.editLayout) {
                drawTermEditScreen(tabStrip, presenter, presenter.view);
                for (let [page, dataWidgets] of presenter.dataWidgets) {
                    if (page === 0)
                        continue;
                    for (let widget of dataWidgets) {
                        widget.afterAttach(presenter.view);
                    }
                }
                presenter.selectPageAndFocusOnFieldIfNeeded();
            } else {
                removeOldTabs(tabStrip, presenter);
            }
        }
    );
}